<template>
    <div class="agencyModal">
        <modal name="modal-class" class="modalStyle" height="auto" :scrollable="true" @closed="closeModal">    
            <div class="modal-title">
                <h2 v-if="isEditPage">Edit Agency</h2>
                <h2 v-else>Create Agency</h2>
            </div>

            <div class="vueInput">
                <v-text-field v-model="newAgencyInfo.code" v-validate="'required'" color="teal" label="Agency Code" :error-messages="errors.collect('Agency Code')" data-vv-name="Agency Code" required box />

                <v-text-field v-model="newAgencyInfo.name" v-validate="'required'" color="teal" label="Agency Name" :error-messages="errors.collect('Agency Name')" data-vv-name="Agency Name" required box />

                <v-text-field v-model="newAgencyInfo.description" color="teal" label="Agency Description" data-vv-name="Agency Description" box />
		    
                <v-textarea v-model="newAgencyInfo.addressLine1" color="teal" label="Agency Address 1" data-vv-name="Agency Address 1" box />

                <v-textarea v-model="newAgencyInfo.addressLine2" color="teal" label="Agency Address 2" data-vv-name="Agency Address 2" box />
		 
                <v-textarea v-model="newAgencyInfo.addressLine3" color="teal" label="Agency Address 3" data-vv-name="Agency Address 3" box />

                <v-text-field v-model="newAgencyInfo.contactNumber" color="teal" label="Agency Contact Number" data-vv-name="Agency Contact Number" box />

                <v-text-field v-model="newAgencyInfo.faxNumber" color="teal" label="Agency Fax Number" data-vv-name="Agency Fax Number" box />

                <v-text-field v-model="newAgencyInfo.personInCharge" color="teal" label="Agency Person In Charge" data-vv-name="Agency Person In Charge" box />

                <div class="save">
                    <v-btn type="button" outline color="teal" @click="saveAgency()">Save</v-btn>

                    <v-btn type="button" outline color="teal" @click="cancelModal()">Cancel</v-btn>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import Vue from "vue";
import VModal from "vue-js-modal";
Vue.use(VModal);


export default {
    props: ["agencyId", "modal", "pageType", "isEditPage", "AgencyInfo" ],
    data () {
        return {
            newAgencyInfo: this.AgencyInfo,
        };
    },
    watch: {
        modal() {
            if (this.modal == true) {
                this.$modal.show("modal-class");
            }
        }
        ,
        AgencyInfo() {
            this.newAgencyInfo = this.AgencyInfo;
        }
    },
    mounted() {
    },
    methods: {
        getAgency(id) {
            var self = this;
            axios({
				  method: "GET",
				  url: "Agency/Get",
				  params: {
				    Id: id
				  }
            })
                .then(function (response) {
                    self.newAgencyInfo = response.data.result;
                });
        },
        cancelModal() {
            this.newAgencyInfo = {};
            this.$modal.hide("modal-class");
        },
        closeModal() {
            this.$emit("update:modal",false);
        },
        saveAgency() {				
            var self = this;
            if (this.isEditPage)
            {
		              axios({
						  method: "PUT",
						  url: "Agency/UPDATE",
						  data: {
						  	"id": self.newAgencyInfo.id,
						  	"name": self.newAgencyInfo.name,
						  	"code": self.newAgencyInfo.code,
						  	"description": self.newAgencyInfo.description,
						  	"addressLine1": self.newAgencyInfo.addressLine1,
						  	"addressLine2": self.newAgencyInfo.addressLine2,
						  	"addressLine3": self.newAgencyInfo.addressLine3,
						  	"personInCharge": self.newAgencyInfo.personInCharge,
						  	"contactNumber": self.newAgencyInfo.contactNumber,
						  	"faxNumber": self.newAgencyInfo.faxNumber
						  }
                })
		              .then(function(response)
	                  {
	                  	alert("Save successful!");
	                    self.newAgencyInfo = {};
	                    if (self.pageType == "1")
	                    {
	                    	self.$emit("updateAgency");
	                    }
		                else
		                {
		                	self.$emit("updateAgencyDetail");
		                }
	                    self.$modal.hide("modal-class");
	                  });
            }
            else
            {
                axios({
						  method: "POST",
						  url: "Agency/Create",
						  data: {
						  	"name": self.newAgencyInfo.name,
						  	"code": self.newAgencyInfo.code,
						  	"description": self.newAgencyInfo.description,
						  	"addressLine1": self.newAgencyInfo.addressLine1,
						  	"addressLine2": self.newAgencyInfo.addressLine2,
						  	"addressLine3": self.newAgencyInfo.addressLine3,
						  	"personInCharge": self.newAgencyInfo.personInCharge,
						  	"contactNumber": self.newAgencyInfo.contactNumber,
						  	"faxNumber": self.newAgencyInfo.faxNumber
						  }
                })
	                    .then(function(response)
	                  {
	                  	alert("Save successful!");
	                    self.newAgencyInfo = {};
	                    if (self.pageType == "1")
	                    {
	                    	self.$emit("updateAgency");
	                    }
		                else
		                {
		                	self.$emit("updateAgencyDetail");
		                }
                    	self.$modal.hide("modal-class");
	                  });	
            }
        }
    }
};
</script>
<style scoped>

    .modal-title {
      padding: 20px 10px 10px 5px;
      margin: 0px 45px;
      border-bottom: 1px solid #b9babd;
    }

    .modalStyle {
      background-color: RGBA(185,186,189,0.8);
    }

    .vueInput {
      padding: 30px 45px;
    }

    .save {
      text-align: center;
    }
    
</style>


// WEBPACK FOOTER //
// src/smallComponents/agencyModal.vue